var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("w-menu-item", {
    staticClass: "w-menu-action action",
    class: { current: _vm.current },
    attrs: { href: _vm.to },
    on: {
      click: function ($event) {
        $event.preventDefault()
        return _vm.doAction.apply(null, arguments)
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function () {
            return [
              _vm._t("icon"),
              _vm._t("label", function () {
                return [
                  _c("span", { staticClass: "text" }, [_vm._t("default")], 2),
                ]
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }